<form #sipManipulationForm="ngForm" autocomplete="off">
    <div class="sip-manipulation-groups-dialog">
        <div class="name">
            <mat-form-field class="fullWidth" >
                <mat-label>Name</mat-label>
                <input matInput [(ngModel)]="data.name" (ngModelChange)="isManipulationGroupValid()"
                       [ngModelOptions]="{standalone: true}"
                       name="manipulation-name" maxlength="255" required>
                <mat-error>
                    Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>

        <div class="manipulation-rules">
            <div class="actions">
                <button cy-data="add" mat-icon-button matTooltip="Add">
                    <mat-icon [svgIcon]="'add'" class="icon-display" (click)="addManipulation()"></mat-icon>
                </button>
            </div>
            <div class="manipulation-rule" *ngFor="let manipulation of data.manipulations; let index = index; let first = first; let last = last">
                <div class="manipulation-rule-row">
                    <ac-input-container label="Condition Group" class="condition-group">
                        <ac-select [(acModel)]="manipulation.conditionGroupId"
                                   [searchable]="true"
                                   [items]="sipConditionGroups"
                                   bindLabel="text"
                                   bindValue="value"
                                   [allowClear]="true">
                        </ac-select>
                    </ac-input-container>

                    <mat-form-field class="action-subject">
                        <mat-label>Action Subject</mat-label>
                        <input matInput [name]="'action-subject-' + index" required
                               [formControl]="manipulation.subjectControl"
                               (ngModelChange)="updateSubjectSuggestions($event, manipulation); this.isManipulationGroupValid();"
                               (focusin)="updateSubjectSuggestions(manipulation.actionSubject, manipulation)"
                               [(ngModel)]="manipulation.actionSubject" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let suggestion of subjectSuggestions" [value]="suggestion">
                                <span [innerHTML]="suggestion | highlight: manipulation.actionSubject"></span>
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error>
                            Value should be a valid subject
                        </mat-error>
                    </mat-form-field>

                    <ac-input-container label="Action Type" class="action-type" (focusout)="actionFocusout(manipulation)"
                                        [customError]="manipulation.actionTypeError" [required]="true">
                        <ac-select [(acModel)]="manipulation.actionType"
                                   [items]="manipulation.actionsOptions"
                                   (acModelChange)="isManipulationGroupValid()"
                                   [allowClear]="true"
                                   [searchable]="true">
                        </ac-select>
                    </ac-input-container>

                    <div class="action-value">
                        <div *ngIf="manipulation.actionType !== 'normalization' && manipulation.actionType !== 'remove' &&
                        manipulation.actionType !== 'randomFromPool' &&
                        manipulation.actionType !== 'sendByWebService'">
                            <mat-form-field class="action-value" (click)="manipulation.isCustomValueOpen = !manipulation.isCustomValueOpen"
                                            cdkOverlayOrigin #trigger="cdkOverlayOrigin">
                                <mat-label>Action Value</mat-label>
                                <input [(ngModel)]="manipulation.actionValue" matInput [name]="'action-value-' + index"
                                       maxlength="255" required [ngModelOptions]="{standalone: true}">
                                <mat-error>
                                    Value is <strong>required</strong>
                                </mat-error>
                            </mat-form-field>
                            <ng-template cdkConnectedOverlay
                                         [cdkConnectedOverlayOrigin]="trigger"
                                         [cdkConnectedOverlayOpen]="manipulation.isCustomValueOpen">
                                <sip-custom-value (onApply)="onAddValueApply($event)" [group]="manipulation"></sip-custom-value>
                            </ng-template>
                        </div>

                        <div *ngIf="manipulation.actionType === 'normalization'">
                            <ac-input-container label="Normalization Group" [customError]="manipulation.normalizationError"
                                                [required]="true" (focusout)="normalizationFocusout(manipulation)">
                                <ac-select [(acModel)]="manipulation.normalizationGroupId"
                                           [items]="normalizationGroupsOptions"
                                           (acModelChange)="isManipulationGroupValid()"
                                           [allowClear]="true"
                                           [bindValue]="'value'"
                                           [bindLabel]="'text'">
                                </ac-select>
                            </ac-input-container>
                        </div>

                        <div *ngIf="manipulation.actionType === 'randomFromPool'">
                            <ac-input-container label="Prefix Group" [customError]="manipulation.prefixGroupError" [required]="true"
                                                (focusout)="prefixGroupFocusout(manipulation)">
                                <ac-select [(acModel)]="manipulation.prefixGroupId"
                                           [items]="prefixGroupsOptions"
                                           (acModelChange)="isManipulationGroupValid()"
                                           [allowClear]="true"
                                           [bindValue]="'value'"
                                           [bindLabel]="'text'">
                                </ac-select>
                            </ac-input-container>
                        </div>

                      <div *ngIf="manipulation.actionType === 'sendByWebService'">
                        <ac-input-container label="Web Service(cutsom)" class="web-service" [required]="true">
                          <ac-select [(acModel)]="manipulation.webServiceId"
                                     [searchable]="true"
                                     [items]="customWebServices"
                                     (acModelChange)="isManipulationGroupValid()"
                                     bindLabel="text"
                                     bindValue="value"
                                     [allowClear]="true">
                          </ac-select>
                        </ac-input-container>
                      </div>

                    </div>

                    <div class="rule-actions">
                        <div class="move-rule-up">
                            <i class="fa fa-arrow-up" [ngClass]="{'fa-disabled': first}" (click)="moveRuleUp(index)"></i>
                        </div>

                        <div class="move-rule-down">
                            <i class="fa fa-arrow-down" [ngClass]="{'fa-disabled': last}" (click)="moveRuleDown(index)"></i>
                        </div>

                        <div class="remove-rule">
                            <i class="fa fa-times" [ngClass]="{'fa-disabled': data.manipulations.length === 1}" (click)="removeRuleDown(index)"></i>
                        </div>
                    </div>
                </div>
              <div
                *ngIf="manipulation.actionType === 'sendByWebService' && manipulation.webServiceId && manipulation.webServiceId !== ''">
                <div class="manipulation-rule-row">

                  <ac-input-container label="Request Method" class="request-method" [required]="true" >
                    <ac-select [(acModel)]="manipulation.requestMethod"
                               [searchable]="true"
                               [items]="requestMethodsOptions"
                               (acModelChange)="isManipulationGroupValid() ; setContentTypeAutomatically(manipulation)"
                               bindLabel="text"
                               bindValue="value">

                    </ac-select>
                  </ac-input-container>


                    <ac-input-container label="Content-Type" [required]="true" class="content-type">
                      <ac-select [(acModel)]="manipulation.requestContentType"
                                 [searchable]="true"
                                 [items]="contentTypeOptions"
                                 (acModelChange)="isManipulationGroupValid()"
                                 ngDisabled="True"
                                 bindLabel="text"
                                 bindValue="value"
                                 [allowClear]="true">
                      </ac-select>
                    </ac-input-container>


                  <mat-form-field class="request-url-suffix" (click)="manipulation.isCustomSuffixOpen = !manipulation.isCustomSuffixOpen"
                                  cdkOverlayOrigin #trigger="cdkOverlayOrigin">
                    <mat-label>Url Suffix</mat-label>
                    <input [(ngModel)]="manipulation.requestUrlSuffix" matInput [name]="'action-requestUrlSuffix-' + index"
                           [ngModelOptions]="{standalone: true}">
                  </mat-form-field>
                  <ng-template cdkConnectedOverlay
                               [cdkConnectedOverlayOrigin]="trigger"
                               [cdkConnectedOverlayOpen]="manipulation.isCustomSuffixOpen">
                    <sip-custom-value (onApply)="onAddSuffixApply($event)" [group]="manipulation"></sip-custom-value>
                  </ng-template>

                    <mat-form-field class="request-body" (click)="manipulation.requestMethod !== 'GET'?
                     manipulation.isJsonEditorOpen = !manipulation.isJsonEditorOpen : null"
                                    cdkOverlayOrigin #trigger="cdkOverlayOrigin">
                      <mat-label>Body</mat-label>
                      <input matInput [name]="'requestBody-'+index"
                             [(ngModel)]="manipulation.requestBody" name="requestBody"
                             [disabled] = "manipulation.requestMethod === 'GET'"
                             />
                      <mat-hint *ngIf="manipulation.requestMethod === 'GET' && (manipulation.requestBody !== null ||
                       manipulation.requestBody !== '')">
                        Body will not be sent for GET request </mat-hint>
                      <ng-template cdkConnectedOverlay
                                   [cdkConnectedOverlayOrigin]="trigger"
                                   [cdkConnectedOverlayOpen]="manipulation.isJsonEditorOpen && manipulation.requestMethod !== 'GET'">
                        <json-editor (onApply)="onAddBodyApply($event)" [group]="manipulation"></json-editor>
                      </ng-template>
                    </mat-form-field>
                </div>
              </div>


              <div class="manipulation-rule-row">
                    <mat-form-field class="description">
                        <mat-label>Description</mat-label>
                        <input [(ngModel)]="manipulation.description" matInput maxlength="1024"
                               [ngModelOptions]="{standalone: true} "/>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</form>
